
<div class="reports-wrapper">
  <div class="reports-card">
    <h2>Reports</h2>
    <form @submit.prevent class="report-form">
      <div class="form-group">
        <label for="reportType">Report Type:</label>
        <select
          id="reportType"
          v-model="selectedReport"
          class="form-control form-control-sm"
          required
        >
          <option value="">-- Select Report Type --</option>
          <option value="accountsValues">Accounts Values Report</option>
          <option value="firmCarryovers">Firm Carryovers Report</option>
          <option value="billing">AdvisorBOB Billing Report</option>
          <option value="delinkedAccounts">Delinked Accounts Report</option>
        </select>
      </div>

      <div v-if="selectedReport" class="report-content">
        <component :is="currentReportComponent"></component>
      </div>
    </form>
  </div>
</div>
